<div class="main d-sm-block d-none" (click)="downloadCSV()">
    DOWNLOAD
    <img src="assets/images/downloadIcon.svg" alt="Download Icon" style="margin-left: 2px;" />
</div>
<div class="main d-sm-none d-flex align-items-center justify-content-center rounded-pill" (click)="downloadCSV()">
    <img src="assets/images/downloadIcon.svg" alt="Download Icon" style="margin-left: 2px;" />
</div>